import { useLang } from 'hooks/lang';

import { packageByStatus } from 'entities';

import { IconButton } from 'components/Blocks';
import { ChangePencilIcon } from 'components/Icons';

import { usePackage } from '../../context';

import { useUser } from 'hooks/user';
import { calculateAmountInvoiced } from '../../utils';
import { usePackageValueChange, withPackageValueChangeContext } from './changeValue.context';

function ChangePackageValue(): JSX.Element | null {
  const { t } = useLang();
  const user = useUser();

  const { data } = usePackage();
  const { open } = usePackageValueChange();

  const canChange = [
    user.type === 'LEADER',
    user.team.isInvoiceTeam,
    Number(data.value) >= calculateAmountInvoiced(data),
    packageByStatus[data.status].canChangeValue,
  ].every(Boolean);

  if (!canChange) return null;

  return (
    <IconButton size="small" tooltipContent={t('change-package-value')} onClick={open}>
      <ChangePencilIcon size={14} />
    </IconButton>
  );
}

export default withPackageValueChangeContext(ChangePackageValue);
